import {

  Component,

  OnDestroy,

  OnInit,
  signal,

} from "@angular/core";
import { HeaderComponent } from "../../../shared/layout/app/header/header.component";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import {
  Details,
  DIVIDEND_FACTOR,
  failurePaymentResultModel,
  initiatePaymentResModel,
  loyaltyApplicableModel,
  ticketsImagesBeforeSelecteingc,
  ticketTypeDeails,
  VerifyRazorpayPaymentRequest,
} from "../ticket-booking.model";
import { FormsModule } from "@angular/forms";
import { TicketBookingBllService } from "../ticket-booking-bll.service";
import { LeftSideNavComponent } from "../../../shared/layout/app/left-menu/left-side-nav.component";
import { LoaderService } from "../../../shared/components/loader/loader.service";
import { DeviceTypeService } from "../../../core/services/device-type.service";
import { UserService } from "../../../core/services/user.service";
import { ProfileBllService } from "../../profile/profile-bll.service";
import { UserEventStatusRespModel } from "../../profile/profile.model";
import { APIErrorModel, BaseResponse } from "../../../shared/models/base-response.model";
import { LoaderComponent } from "../../../shared/components/loader/loader.component";
import { HomeBllService } from "../../home/home-bll.service";
import { EventDetailsResponseModel } from "../../home/home.model";

@Component({
  standalone: true,
  selector: "app-ticket-summary",
  imports: [HeaderComponent, CommonModule, FormsModule, LeftSideNavComponent, LoaderComponent],
  templateUrl: "./ticket-summary.component.html",
  styleUrl: "./ticket-summary.component.scss",
})

export class TicketSummaryComponent implements OnInit, OnDestroy {
  // @ViewChild("PaymentFailedModal") paymentfailure!: ElementRef;


  ticketDetails: ticketTypeDeails[] = [];
  total: number = 0;
  // loyaltyDiscount: number = 50; // Assuming you have a loyalty discount logic
  subtotal: any;
  saved: number = 0; // Assuming you have a saved amount logic
  totalSaved: number = 0;
  ticketsImagesBeforeSelecteingc: {
    [key: string]: { black: string; color: string };
  } = ticketsImagesBeforeSelecteingc;
  termsAccepted: boolean = true; // To track if terms are accepted
  // In a real app you'd get this from your backend’s Orders API
  orderId: string = ""; // To store the order ID after booking confirmation
  amount: number = 0;
  details: Details | null = null; // To store registration details
  // To store full name and mobile number for Razorpay payment
  fullName: string = "";
  mobile: string = "";
  discount: number = 0; // Assuming you have a discount logic
  isMobileDevice: boolean = false;
  isPaymentInProgress = false;
  transactionId: string = '';
  private pollTimeout: any = null;
  private isDestroyed = false;
  private isNavigated = false;
  loyaltyDiscount: loyaltyApplicableModel[] = [
    {
      code: "",
      discount_amount: "",
      display_name: "",
      id: "",
    },
  ];

  /**
     * User profile data
     */
  userProfile: UserEventStatusRespModel["user_profile"] | null = null;

  previewLogo: string = '/assets/images/Default-profile-photo.png'; // String path/URL

  eventDetails: EventDetailsResponseModel | null = null;
  summaryId: string | null = null;
  loading = signal(false);
  sdkReady = signal(false);

  constructor(
    private router: Router,
    private bllService: TicketBookingBllService,
    private loaderService: LoaderService,
    private deviceService: DeviceTypeService,
    private profileBll: ProfileBllService,
    private userService: UserService,
    private homeBll: HomeBllService

  ) { }

  ngOnInit(): void {
    // Retrieve ticket details from local storage
    this.summaryId = this.bllService.getSummaryIdFromStorage();
    // this.loadRazorpayScript();
    if (this.summaryId) {
      this.loadRegistrationDetails(this.summaryId);
    }
    this.fetchUserEventStatus();
    // Fetch user event status and profile

    this.loyaltyDiscount = this.bllService.getUserDiscounts() || [];

    this.isMobileDevice = this.deviceService.isMobile();

    this.loadEventDetails();

  }



  // Load registration details from the backend
  async loadRegistrationDetails(summaryId: string): Promise<void> {
    try {
      // this.loaderService.show();

      // ✅ prevent execution after destroy
      if (this.isDestroyed) return;

      const result = await this.bllService.getRegistrationDetails(summaryId); // returns details object

      this.details = result?.details ?? null;

      // ✅ keep amount available for payment-in-progress screen
      this.amount = Number(this.details?.paid_amount);
      this.transactionId = this.details?.transaction_id || '';
      this.ticketDetails = result?.ticket_type_details;

      // ✅ Payment still in progress → keep polling
      if (this.details?.status !== "paid" && this.details?.razorpay_authorised_datetime != null) {
        this.isPaymentInProgress = true;

        // ✅ clear previous timeout
        if (this.pollTimeout) {
          clearTimeout(this.pollTimeout);
        }

        this.pollTimeout = setTimeout(() => {
          if (this.isDestroyed) return; // ✅ prevent after destroy

          this.loadRegistrationDetails(this.summaryId!);
        }, 10000);

        return;
      }

      // ✅ 🔥 Payment completed → navigate immediately
      if (this.details?.status === "paid" && !this.isNavigated) {
        this.isNavigated = true;

        this.isPaymentInProgress = false;

        // ✅ clear polling
        if (this.pollTimeout) {
          clearTimeout(this.pollTimeout);
          this.pollTimeout = null;
        }

        this.router.navigate(["/reg/assign-ticket"], {
          replaceUrl: true,
        });

        return;
      }

      // ✅ Payment not in progress (fallback)
      this.isPaymentInProgress = false;

      // ------------------------------------------------------------------

      if (this.details) {
        const first = this.details.first_name ?? "";
        const last = this.details.last_name ?? "";
        this.fullName = `${first} ${last}`.trim() || "—";
        this.mobile = this.details.mobile1 ?? "—";
        this.discount = this.details.discount_amount ?? 0;
      } else {
        this.fullName = "—";
        this.mobile = "—";
      }

      this.calculateTotal();

    } catch (error) {
      console.error("Error while loading registration details:", error);
      this.fullName = this.mobile = "—";
    }
  }
  calculateTotal(): void {
    this.total = this.ticketDetails.reduce(
      (sum, ticket) => sum + Number(ticket.paid_amount),
      0
    );

    this.saved = this.ticketDetails.reduce(
      (sum, ticket) => sum + Number(ticket.display_price),
      0
    ); // Assuming a 10% discount for loyalty

    this.subtotal =
      this.loyaltyDiscount.length !== 0
        ? this.total - parseInt(this.loyaltyDiscount[0]?.discount_amount)
        : this.total;
    this.totalSaved = this.saved - this.subtotal;
  }

  goBack() {
    this.router.navigate(["/reg/select-ticket"]);
  }

  toggleTermsAcceptance(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.termsAccepted = checkbox.checked;
    // Alternatively, you can toggle the acceptance state

    console.log("Terms accepted:", this.termsAccepted);
  }


  /**
   * Called when the user clicks “Pay Now”
   * call initial booking API
   */
  confirmBooking(): void {
    this.loaderService.show();
    // Call the initial booking API
    this.bllService
      .confirmBooking()
      .then((response: initiatePaymentResModel) => {
        this.loaderService.hide();

        console.log("Booking confirmed:", response);
        this.orderId = response?.id; // Update orderId if provided
        this.amount = response?.amount || 0; // Update amount if provided
        this.openPayment(response); // Open Razorpay payment popup
      })
      .catch((error) => {
        console.error("Error confirming booking:", error);
        //if 409 then call summary after 10 sec
        if (error?.status === 409) {
          this.loaderService.hide();
          this.isPaymentInProgress = true;

          // ✅ clear previous timeout
          if (this.pollTimeout) {
            clearTimeout(this.pollTimeout);
          }

          this.pollTimeout = setTimeout(() => {
            if (this.isDestroyed) return;

            this.loadRegistrationDetails(this.summaryId!);
          }, 10000);

          return;
        }
        this.loaderService.hide();
        console.error("Error confirming booking:", error);
        alert(error.message);
      });
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;

    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
      this.pollTimeout = null;
    }
  }

  /**   * Opens the Razorpay payment popup.
   *
   * @param data - Payment initiation response from backend
   */

  async openPayment(data: initiatePaymentResModel): Promise<void> {
    console.log(this.fullName, this.mobile, data);

    this.bllService.payWithRazor(
      this.fullName,
      this.mobile,
      data,

      // ✅ Payment successful
      (response) => {
        console.log('Payment successful:', response);

        const payload: VerifyRazorpayPaymentRequest = {
          razorpay_order_id: response?.razorpay_order_id || '',
          razorpay_payment_id: response?.razorpay_payment_id || '',
          razorpay_signature: response?.razorpay_signature || '',
        };

        this.verifyPaymentOnBackend(payload);
      },

      // ❌ Payment failed / dismissed
      (error) => {
        this.loaderService.hide();

        // Case-1: user closed popup (service sends { error: 'Payment popup closed.' })
        if (error?.error === 'Payment popup closed.') {
          console.warn('Payment dismissed by user.');
          return;
        }

        // Case-2: Razorpay payment.failed event payload
        const rzpErr = error?.error ?? {};
        const meta = rzpErr?.metadata ?? {};

        // Prepare failure payload
        const payload: failurePaymentResultModel = {
          razorpay_order_id: meta?.order_id || data?.id || '',
          razorpay_payment_id: meta?.payment_id || '',
          error_code: rzpErr?.code || '',
          error_description: rzpErr?.description || '',
        };

        // Send failure details to backend
        this.paymentFailed(payload);
        console.error('Payment failed:', error);
      }
    );
  }

  // Handle payment failure by notifying the backend
  private paymentFailed(payload: failurePaymentResultModel): void {
    this.bllService.failurePayment(payload).then((response) => {
      console.log("Payment failure recorded:", response);
    }).catch((error) => {
      console.error("Error recording payment failure:", error);
    });

  }

  /**
   * Verifies the Razorpay payment with backend.
   *
   * @param payload - Payment verification request object
   */
  private verifyPaymentOnBackend(payload: VerifyRazorpayPaymentRequest): void {
    this.loaderService.show();
    this.bllService
      .verifyPayment(payload) // returns Promise<string>
      .then((message: string) => {

        console.log("Verification success:", message);
        // ✅ Navigate after success
        /**
         * Using setTimeout to ensure that the navigation happens after the current call stack is cleared.
         * This helps avoid potential ExpressionChangedAfterItHasBeenCheckedError errors in Angular.
         */
        this.loaderService.hide();
        this.router.navigate(["reg/payment-success"], {
          queryParams: { orderId: this.orderId, value: this.amount / DIVIDEND_FACTOR },
          replaceUrl: true
        });
      })
      .catch((err: Error) => {
        this.loaderService.hide();
        console.error("Verification failed:", err);
        // Show payment failure modal
        // this.showPaymentFailureModal();
      });
  }

  fetchUserEventStatus() {
    this.loaderService.show();
    this.profileBll
      .submitGetUserEventStatus()
      .then((res: BaseResponse<UserEventStatusRespModel>) => {
        this.userProfile = res.data.user_profile;
        if (this.userProfile) {
          if (this.userProfile.image_url) {
            this.previewLogo = this.userProfile.image_url ?? "/assets/images/Default-profile-photo.png";
          }


          let userName =
            res.data.user_profile.first_name +
            " " +
            res.data.user_profile.last_name;
          this.userService.setUser({
            name: userName, // get from API or JWT
            profileImg: this.previewLogo, // fallback if empty
            mobile: res.data.user_profile.mobile,
            state: res.data.user_profile.state,
            city: res.data.user_profile.city,
            hasUnassignedTickets: res.data.event_my_tickets.unassigned_tickets_bought_by_me > 0,
            hasAssignedTickets: res.data.event_my_tickets.assigned_tickets_bought_by_me > 0 || res.data.event_my_tickets.tickets_assigned_for_me > 0,
          });

        }
        this.loaderService.hide();
      })
      .catch((err: APIErrorModel) => {
        this.loaderService.hide();
        console.error("Error fetching user event status:", err);
        alert("Failed to fetch user event status. Please try again.");
      });
  }

  /**
* Indicates whether the loader is currently shown.
* Returns `true` if the loader service is active, otherwise `false`.
*/
  get isLoading(): boolean {
    return this.loaderService.isShown;
  }

  getTotalPrice(item: any): number {
    const price = Number(item.display_price);
    const count = Number(item.register_people_count);
    return (isNaN(price) ? 0 : price) * (isNaN(count) ? 0 : count);
  }

  loadEventDetails() {
    this.homeBll.fetchEventDetails()
      .then((response) => {
        this.eventDetails = response.data;
        this.userService.setLeftMenu({
          allow_to_register: this.eventDetails.allow_to_register,
          show_digital_catalog: this.eventDetails.show_digital_catalog,
          event_status: this.eventDetails.event_status
        });
      })
      .catch((error) => {
        console.error('Error fetching event details:', error);
      });
  }

}
